import { render, staticRenderFns } from "./dataCleaning.vue?vue&type=template&id=420d148a&scoped=true&"
import script from "./dataCleaning.vue?vue&type=script&lang=js&"
export * from "./dataCleaning.vue?vue&type=script&lang=js&"
import style0 from "./dataCleaning.vue?vue&type=style&index=0&id=420d148a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420d148a",
  null
  
)

export default component.exports